// extracted by mini-css-extract-plugin
export default {"verticalTabList":"VerticalTabList_verticalTabList__p3-W9","verticalTabItem":"VerticalTabList_verticalTabItem__tQLgG"};